// extracted by mini-css-extract-plugin
export default {"container":"styles_container__A-zoT","row":"styles_row__DsGBt","high":"styles_high__3F3b9","low":"styles_low__y18XN","highLowContainer":"styles_highLowContainer__PiG+T"};